<template lang="pug">
  div redirect...
</template>

<script>
export default {
  mounted() {
    location.href = '/member.html#/member/language'
  }
}
</script>